import React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";
import { DownloadBtn } from "./CardContactStyles";


export const CardContact = (props: any) => {

    const { t, i18n } = useTranslation();

    const open_contact_form = () => {
        window.gtag('event','contact_addin_open',{'event_category':'engagement','event_label':props.name});

        const form = document.getElementById("form") as HTMLFormElement;
        
        const form_ta = document.getElementById("form-text-area") as HTMLTextAreaElement;
        form_ta.value = "Hi, I would like to request the " + props.name + " Add-in. How do we proceed?";
        
        form.submit();

    };

    return (
        <>
            <div
                onClick={open_contact_form}
                role="button"
                className="btn-robot-link center-block"
            >
                <DownloadBtn
                    type="submit"
                    formMethod="post"
                    formAction="https://robodk.com/contact?request-addin"
                >
                    <strong>{t('library-overlays.cardContactBtn')}</strong>
                </DownloadBtn>
            </div>
        </>
    )
};
